import React, { useState, useEffect } from "react"
import { Form } from "react-bootstrap"
import { Row, Col, Container } from "react-bootstrap"

var d = new Date()
var n = d.getHours() - 4
// console.log("time",n)

function myplaceholder(props) {
  return <div>{props.html}</div>
}

function createMarkup(props) {
  return { __html: props.html }
}

function MyComponent(props) {
  return <div dangerouslySetInnerHTML={createMarkup(props)} />
}
const RadioboxField = ({
  fieldClass,
  name,
  value,
  required,
  placeholder,
  handlechange,
  checked,
  selectedDateValues,
  lastchild,
  step,
  type,
  grpmd,
}) => {

  var day = selectedDateValues?.getDay()

  const isSmallerThanLondonTime = (selectedTime, status) =>{
    let d = new Date()
    let today_day = d?.getDay()
    let utc = d.getTime() + d.getTimezoneOffset() * 60000
    let nd = new Date(utc + 3600000 * "+1")
    let londonTime = nd.toLocaleTimeString("en-US", {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
    })

    var finalFlagStatus = londonTime > selectedTime
    
    var userDate = selectedDateValues?.getTime();
    var todayDate = nd?.getTime();
    var diff = userDate - todayDate;

    var d1 = selectedDateValues?.getDate();
    var d2 = nd.getDate();
    var minus = Math.trunc(diff / (1000 * 60 * 60 * 24));
    
    var mondayTimeDisabledFlag = today_day === 0 | today_day === 6 ? true : false

    if(day === 0 && status === "disable"){
        return true
    }
    if(day === 0 && status === "check"){
      return false
    }

    if(status === "disable" && d1 == d2 && minus === 0){
      return finalFlagStatus
    }

    if(status === "disable" && minus >= 0 && d1 != d2){
      if(selectedTime === "09:00" && minus === 0 && d1 != d2){
        return true
      }
      if(mondayTimeDisabledFlag && selectedTime === "09:00" && day === 1 && minus <= 1){
        return true
      }
      return false
    }

    if(status === "check"){
      return !finalFlagStatus
    }
  }

  const times = [
    "09:00",
    "10:00",
    "11:00",
    "12:00",
    "13:00",
    "14:00",
    "15:00",
    "16:00",
    "17:00",
    "18:00",
  ]

  const saturedayTimes = [
    "09:00",
    "10:00",
    "11:00",
    "12:00",
    "13:00",
    "14:00",
    "15:00",
  ]
  return (
    <>
      {type == "time_radio" ? (
        <Form.Group
          as={Col}
          md={grpmd}
          className={`${type} ${step}`}
          controlId={"validation" + name}
        >
          <div class="radio-toolbar">
              { (day === 6 ? saturedayTimes : times).map((time, i) => {
                return (
                  <div key={"radiocol" + i} className="radio-item">
                    <input
                      key={"radio" + i}
                      type="radio"
                      id={`radio${i + 1}`}
                      name="val_time"
                      value={time}
                      disabled={isSmallerThanLondonTime(time, "disable")}
                      checked={isSmallerThanLondonTime(time, "check")}
                    />
                    <label for={`radio${i + 1}`}>{time}</label>
                  </div>
                )
              })}
          </div>
        </Form.Group>
      ) : (
        <div className={`form-group radio-wrap ${lastchild} ${step}`}>
          <label className="radio-label">
            <input
              type="radio"
              id={name}
              name={name}
              value={value}
              checked={checked}
              onChange={handlechange}
            />
            <span className="radio-ico"></span>
            {value}
          </label>
        </div>
      )}
    </>
  )
}
export default RadioboxField
